import { ExpandLess, ExpandMore } from "@mui/icons-material";
import intl from "react-intl-universal";

export const ExtractTimelineToggleAll = ({ allExpanded, onToggle }) => (
  <div className="extract-timeline-toggle-all-wrap">
    <button
      type="button"
      className="extract-timeline-toggle-all"
      onClick={onToggle}
      aria-expanded={allExpanded}
    >
      {allExpanded ? (
        <ExpandLess sx={{ fontSize: 16 }} />
      ) : (
        <ExpandMore sx={{ fontSize: 16 }} />
      )}
      <span>{intl.get(allExpanded ? "extract.collapseAll" : "extract.expandAll")}</span>
    </button>
  </div>
);
